import IndustryUseCases from './industry-usecase';

export default IndustryUseCases;
